export class HomeRiskData {
    combinedFamilyId: number;
    combinedFamilyName: string;
    price: number;
    coverages?: Array<string>
}
